import { Component, OnInit, inject } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { ButtonModule } from 'primeng/button';
import {
  EnumService,
  InstituicaoEnsinoService,
  RepresentacaoInstituicaoEnsinoService,
  TipoRepresentacaoInstituicaoEnsinoService,
} from '../../api/services';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from '@angular/forms';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { Select } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { dateRangeValidator } from '@core/validators/date-range.validator';
import { RepresentanteCardComponent } from './components/representante-card/representante-card.component';
import { AuthService } from '@core/service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { DatePickerModule } from 'primeng/datepicker';
import { FluidModule } from 'primeng/fluid';
import { InputMaskModule } from 'primeng/inputmask';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-add-representante',
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    BackButtonComponent,
    Select,
    InputTextModule,
    CalendarModule,
    RepresentanteCardComponent,
    ConfirmDialog,
    FileUploadModule,
    DatePickerModule,
    FluidModule,
    InputMaskModule,
    ConfirmDialogModule,
    ToastModule,
  ],
  providers: [
    ApiService,
    TipoRepresentacaoInstituicaoEnsinoService,
    InstituicaoEnsinoService,
    RepresentacaoInstituicaoEnsinoService,
    ConfirmationService,
    AuthService,
    MessageService,
    EnumService,
  ],
  templateUrl: './add-representante.component.html',
  styleUrls: ['./add-representante.component.scss'],
  standalone: true,
})
export class AddRepresentanteComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  private representanteInstituicaoEnsinoService = inject(
    RepresentacaoInstituicaoEnsinoService,
  );
  private enumService = inject(EnumService);
  private messageService = inject(MessageService);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService);
  tiposRepresentacao: any[] = [];
  representacaoForm: any;
  nacionalidades: any[] = [];
  representantes: any[] = [];
  editIndex: number | null = null;
  private tipoRepresentacaoService = inject(
    TipoRepresentacaoInstituicaoEnsinoService,
  );
  isInternalInstitution: boolean = false;
  profileEducationalInstitution: any;
  isLoading: boolean = false;
  isPatching = false;
  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  ngOnInit(): void {
    this.loadTiposRepresentacao();
    this.loadNacionalidade();
    this.representacaoForm = this.fb.group({
      nome: ['', Validators.required],
      telefone: ['', [Validators.required]],
      bi: ['', Validators.required],
      emailRepresentante: ['', [Validators.required, Validators.email]],
      tipoRepresentacaoInstituicaoEnsinoID: ['', Validators.required],
      NacionalidadeEnum: ['', Validators.required],
      ativo: [true],
      usernameRepresentante: [''],
      instituicaoEnsinoID: [this.instituicaoEnsinoID, Validators.required],
      foto: [''],
    });

    this.representacaoForm.controls.NacionalidadeEnum.valueChanges.subscribe(
      (value: any) => {
        if (this.isPatching) return;
        this.representacaoForm.patchValue({
          bi: '',
        });
        this.onNacionalidadeChange(value);
      },
    );

    this.representacaoForm.controls['bi'].valueChanges.subscribe(() => {
      if (this.isPatching) return;

      //TODO: reset form control nome
      this.representacaoForm.patchValue({
        nome: '',
        telefone: '',
        // emailRepresentante: '',
      });
    });

    this.loadInstitutionDetails();
    // Inicializa comportamento correto de telefone no início
    // this.representacaoForm.controls.NacionalidadeEnum.patchValue(this.nacionalidades[0]?.id);
  }

  loadNacionalidade() {
    this.enumService.getAllNacionalidadeEnum().subscribe((response) => {
      if (response?.data) {
        this.nacionalidades = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
    });
  }

  get f() {
    return this.representacaoForm.controls;
  }

  get instituicaoEnsinoID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  loadInstitutionDetails(): void {
    this.instituicaoEnsinoService
      .show(this.instituicaoEnsinoID)
      .subscribe((data: any) => {
        this.profileEducationalInstitution = data;
      });
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  editRepresentante(representante: any, index: number) {
    this.isPatching = true;
    this.representacaoForm.patchValue(representante);

    this.representacaoForm.patchValue({
      nome: representante.nome,
      telefone: representante.telefone,
    });

    // Refatora: Telefone e Email devem estar editáveis se nacionalidade for nacional (id == 1)
    this.onNacionalidadeChange(representante.NacionalidadeEnum);

    ['telefone', 'emailRepresentante'].forEach((controlName) => {
      this.representacaoForm.get(controlName)?.enable();
    });

    this.selectedFile = representante.foto;
    if (representante.foto && representante.foto instanceof File) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(representante.foto);
    } else {
      this.imagePreview = null;
    }
    this.editIndex = index;
    this.isPatching = false;
  }

  deleteRepresentante(representante: any, index: number) {
    this.confirmationService.confirm({
      header: 'Confirmar Exclusão?',
      message: `Tem certeza que deseja excluir ${representante.nome}?`,
      accept: () => {
        this.representantes.splice(index, 1); // Remove o item do array
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Representante excluído com sucesso!',
          life: 3000,
        });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Exclusão cancelada',
        });
      },
    });
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    const extension = this.file.name.split('.').pop()?.toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Extensão inválida',
        detail: 'A imagem deve ser JPG ou PNG.',
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.representacaoForm.patchValue({ foto: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
  }

  save(data: any) {
    this.confirmationService.confirm({
      header: 'Confirmar Representante?',
      message: `Tem certeza que deseja salvar?`,
      rejectButtonProps: {
        label: 'Cancelar',
        icon: 'pi pi-times',
        outlined: true,
        size: 'small',
      },
      acceptButtonProps: {
        label: 'Sim',
        icon: 'pi pi-check',
        size: 'small',
      },
      accept: () => {
        this.store(this.representantes);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelada',
          detail: 'Representantes cancelados',
        });
      },
    });
  }

  onConfirmSave(data: any) {
    // this.store(data);
  }

  onRejectSave() {
    this.messageService.clear('confirmDialog');
  }

  /**
   * Se nacionalidade for nacional (id == 0), campo telefone só aceita +244 e inputmask é aplicado.
   * Se for estrangeira, aceita qualquer telefone (sem inputmask fixo +244).
   */
  onNacionalidadeChange(value: any) {
    this.isInternalInstitution = value === 1;
    // TELEFONE: Muda o comportamento do campo dinamicamente
    const telefoneControl: FormControl = this.representacaoForm.get('telefone');
    if (this.isInternalInstitution) {
      // Nacional: aplica máscara angolana
      telefoneControl.setValidators([Validators.required]);
      telefoneControl.updateValueAndValidity();
      telefoneControl.enable();
      this.representacaoForm.get('nome')?.disable();
      this.representacaoForm.get('emailRepresentante')?.disable();
      this.representacaoForm.get('telefone')?.disable();
    } else {
      // Estrangeira: permite qualquer formato, sem máscara fixa
      telefoneControl.setValidators([Validators.required]);
      telefoneControl.updateValueAndValidity();
      telefoneControl.enable();
      this.representacaoForm.get('nome')?.enable();
      this.representacaoForm.get('emailRepresentante')?.enable();
    }
  }

  searchDocumentNumber() {
    const biVal = this.f['bi']?.value;
    if (!biVal) return;

    this.authService.consultarBi(biVal).subscribe((result) => {
      const isSuccess =
        result?.retorno?.codigo == 200 ||
        result?.data?.code == 200 ||
        result?.data?.codigo == 200;
      if (isSuccess) {
        const personData = result.data?.data || result.data || {};
        const firstName = personData.first_name || personData.nome || '';
        const lastName = personData.last_name || personData.sobrenome || '';
        const nomeCompleto = `${firstName} ${lastName}`.trim();

        const patchValues: any = {};
        if (nomeCompleto) {
          patchValues.nome = nomeCompleto;
        }
        if (personData.numeroContacto || personData.telefone) {
          patchValues.telefone =
            personData.numeroContacto || personData.telefone;
        }
        if (personData.email) {
          patchValues.emailRepresentante = personData.email;
        }

        this.representacaoForm.patchValue(patchValues);

        this.representacaoForm.controls['emailRepresentante'].enable();
        this.representacaoForm.controls['telefone'].enable();
      }
    });
  }

  loadTiposRepresentacao() {
    this.tipoRepresentacaoService.list().subscribe((tiposRepresentacao) => {
      this.tiposRepresentacao = tiposRepresentacao;
    });
  }

  store(data: any[]) {
    if (this.representantes.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Nenhum representante para cadastrar.',
        life: 3000,
      });
      return;
    }
    this.isLoading = true;

    const total = data.length;
    let processed = 0;
    let errors = 0;
    let errorMessages: string[] = [];

    data.forEach((representante: any) => {
      const formData = new FormData();

      formData.append('emailRepresentante', representante.emailRepresentante);
      formData.append('nome', representante.nome);
      formData.append('telefone', representante.telefone);
      formData.append(
        'usernameRepresentante',
        representante.usernameRepresentante,
      );
      formData.append(
        'tipoRepresentacaoInstituicaoEnsinoID',
        representante.tipoRepresentacaoInstituicaoEnsinoID.toString(),
      );
      formData.append(
        'instituicaoEnsinoID',
        representante.instituicaoEnsinoID.toString(),
      );
      formData.append('ativo', representante.ativo.toString());

      // Campos opcionais
      if (representante.NacionalidadeEnum) {
        formData.append('NacionalidadeEnum', representante.NacionalidadeEnum);
      }
      if (representante.bi) {
        formData.append('bi', representante.bi);
      }
      if (representante.foto) {
        formData.append('foto', representante.foto);
      }

      this.representanteInstituicaoEnsinoService.store(formData).subscribe(
        (response) => {
          processed++;
          // Checa status code do backend
          if (response?.retorno?.codigo && response.retorno.codigo !== 200) {
            errors++;
            const msg =
              response.retorno.mensagem || 'Erro ao cadastrar representante.';
            errorMessages.push(msg);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: msg,
              life: 4000,
            });
          }
          if (processed + errors === total) {
            this.isLoading = false;
            this.finalizeSubmission(errors, errorMessages, total);
          }
        },
        (error) => {
          errors++;
          processed++;
          let detail = 'Erro ao cadastrar representante.';
          if (error?.error?.retorno?.mensagem) {
            detail = error.error.retorno.mensagem;
          }
          errorMessages.push(detail);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail,
            life: 4000,
          });
          if (processed + errors === total) {
            this.isLoading = false;
            this.finalizeSubmission(errors, errorMessages, total);
          }
        },
      );
    });
  }

  private finalizeSubmission(
    errors: number,
    errorMessages: string[],
    total: number,
  ) {
    if (errors === 0) {
      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Todos os representantes foram cadastrados com sucesso!',
        life: 3000,
      });
      this.router.navigate([
        '/gestao-bolseiros/instituicao-ensino/detalhe-instituicao',
        this.instituicaoEnsinoID,
      ]);
    } else if (errors === total) {
      this.messageService.add({
        severity: 'error',
        summary: 'Falha total',
        detail: errorMessages.join(' | '),
        life: 7000,
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Parcialmente concluído',
        detail: `Falharam ${errors} de ${total} representantes. Erros: ${errorMessages.join(
          ' | ',
        )}`,
        life: 7000,
      });
    }
  }

  onSubmit() {
    if (this.representacaoForm.valid) {
      const value = this.representacaoForm.getRawValue();
      value.usernameRepresentante = !this.isInternalInstitution
        ? value.emailRepresentante
        : value.bi;
      value.foto = this.selectedFile; // <- define a imagem corretamente
      if (this.editIndex !== null) {
        this.representantes[this.editIndex] = value;
        this.editIndex = null;
      } else {
        this.representantes.push(value);
      }
      this.representacaoForm.reset();
      this.isInternalInstitution = false;
      this.representacaoForm.patchValue({
        instituicaoEnsinoID: this.instituicaoEnsinoID,
        ativo: true,
      });
      this.imagePreview = null; // Limpa a imagem após o envio
      this.selectedFile = null; // Limpa o arquivo após o envio
      this.fotoPreviewMap = {}; // Limpa o mapa de pré-visualização
      this.representacaoForm.get('foto')?.reset(); // Limpa o campo de arquivo
    } else {
      this.representacaoForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
    }
  }
}
